import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { View, TouchableOpacity } from 'react-native'
import { createContainer } from '@dbk-legacy/muster/react'
import Text from '@dbk/ui-text'
import Modal from '@dbk/ui-modal'
import costsList from '../../../../data/payment-costs-list.json'
import { QuestionMark } from '../../../../components/common/icons'

class PymtCharge extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      costsModalVisible: false,
    }

    this.handleIconPress = this.handleIconPress.bind(this)
    this.handleDone = this.handleDone.bind(this)
  }

  componentDidUpdate(){
    if(document.querySelector('div .chargeOptionFocus')){
      document.querySelector('div .chargeOptionFocus').focus();
    }
  }

  handleIconPress() {
    this.setState({
      costsModalVisible: true,
    })
  }

  handleDone() {
    this.setState({
      costsModalVisible: false,
    })
    this.forceUpdate()
  }

  render() {
    const {
      i18n: { messages },
    } = this.props
    const { costsModalVisible } = this.state
    const costs = costsList.costsList

    return (
      <View>
        <TouchableOpacity onPress={this.handleIconPress}>
          <div style={{marginLeft: 10}} aria-label={messages['app.payments.feeschargeOptions']}>
            <QuestionMark width={20} height={20} color={'#ffffff'} />
          </div>
        </TouchableOpacity>
        <View>
          <Modal
            isActive={costsModalVisible}
            onClose={this.handleDone}
            header={<Text secondary>{messages['app.payments.feeschargeOptions']}</Text>}
            tabIndex={0}
            content={
              <div>
                {costs && costs.length &&
                costs.map((val, i) => (
                  <div key={val.id} style={{ margin: 20, marginLeft:40 }}>
                    <div tabIndex={0} className={i === 0 ? 'chargeOptionFocus': ""}><Text secondary>{messages[val.title]}</Text></div>
                    <div tabIndex={0}><Text>{messages[val.desc]}</Text></div>
                  </div>
                ))}
              </div>
            }
          />
        </View>
      </View>
    )
  }
}

PymtCharge.propTypes = {
  i18n: PropTypes.object.isRequired,
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
  },
})(PymtCharge)
